// Source: http://unicode.org/cldr/trac/browser/tags/release-27/common/main/en.xml#L1847
module["exports"] = {
  wide: [
    "الأحَد",
    "الإثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت",
  ],

  wide_context: [
    "الأحَد",
    "الإثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت",
  ],
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/ar/date/weekday.js
// module id = 2406
// module chunks = 1610